import { render, staticRenderFns } from "./Labs.vue?vue&type=template&id=76217f44&scoped=true&"
import script from "./Labs.vue?vue&type=script&lang=ts&"
export * from "./Labs.vue?vue&type=script&lang=ts&"
import style0 from "./Labs.vue?vue&type=style&index=0&id=76217f44&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76217f44",
  null
  
)

export default component.exports